// extracted by mini-css-extract-plugin
export default {"articles":"Y_fiUqzykUR4n_VJ68TH"};